var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHireDriverB2B(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.3939 52.5552H10.1613C5.09968 52.5552 1 48.4555 1 43.3939V10.1613C1 5.09968 5.09968 1 10.1613 1H43.3939C48.4555 1 52.5552 5.09968 52.5552 10.1613V43.3939C52.5552 48.444 48.444 52.5552 43.3939 52.5552Z",
    fill: "#F2FFFA",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0315 18.2812H30.8202C30.8202 16.0282 28.9912 14.2113 26.7503 14.2113C24.4973 14.2113 22.6683 16.0282 22.6683 18.2812H21.457C21.4691 15.362 23.8433 13 26.7503 13C29.6695 13 32.0315 15.362 32.0315 18.2812Z",
    fill: "#09081A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5701 40.4594H15.9367C13.7685 40.4594 12 38.6909 12 36.5227V21.5997C12 19.4316 13.7685 17.6631 15.9367 17.6631H37.5822C39.7504 17.6631 41.5189 19.4316 41.5189 21.5997V34.0759H40.3076V21.5997C40.3076 20.0978 39.0842 18.8744 37.5822 18.8744H15.9367C14.4347 18.8865 13.2113 20.0978 13.2113 21.5997V36.5227C13.2113 38.0247 14.4347 39.2481 15.9367 39.2481H37.5822C39.0842 39.2481 40.3076 38.0247 40.3076 36.5227H41.5189C41.5068 38.6909 39.7383 40.4594 37.5701 40.4594Z",
    fill: "#09081A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1976 32.308H23.1317C17.1237 32.308 12.2423 27.6082 12 21.6245L12.6056 21.4307H13.2113V21.5033C13.4172 26.9057 17.7778 31.0967 23.1317 31.0967H24.1976V32.308Z",
    fill: "#09081A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3745 32.308H29.3086V31.0967H30.3745C35.7405 31.0967 40.089 26.9178 40.2949 21.576L41.5062 21.4307C41.5062 21.4428 41.5062 21.6124 41.5062 21.6124C41.276 27.6203 36.3946 32.308 30.3745 32.308Z",
    fill: "#09081A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3943 34.6817H25.136V33.4704H28.3943C28.576 33.4704 28.7214 33.325 28.7214 33.1433V29.885C28.7214 29.7033 28.576 29.558 28.3943 29.558H25.136C24.9543 29.558 24.8089 29.7033 24.8089 29.885V33.1433C24.8089 33.325 24.9543 33.4704 25.136 33.4704V34.6817C24.2881 34.6817 23.5977 33.9912 23.5977 33.1433V29.885C23.5977 29.0371 24.2881 28.3467 25.136 28.3467H28.3943C29.2422 28.3467 29.9327 29.0371 29.9327 29.885V33.1433C29.9205 33.9912 29.2301 34.6817 28.3943 34.6817Z",
    fill: "#09081A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.301 35.6895L15.3203 35.6896V37.4539L20.301 37.4538V35.6895Z",
    fill: "#05D383"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHireDriverB2B);
export default __webpack_public_path__ + "static/media/HireDriverB2B.1a05cf5b.svg";
export { ForwardRef as ReactComponent };